// ChatWindow.jsx
const ChatWindow = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <div className="flex justify-between items-center p-4 border-b">
        <button>&larr;</button>
        <div className="font-bold">John DoE <span className="text-green-500 text-sm ml-1">● Live</span></div>
        <div></div>
      </div>

      <div className="flex-1 p-4 space-y-4 overflow-y-auto">
        <div className="self-end bg-primary text-white px-4 py-2 rounded-lg max-w-xs ml-auto">Hi Sir</div>
        <div className="self-end bg-primary text-white px-4 py-2 rounded-lg max-w-xs ml-auto">
          I need to know the privacy policy of your business in a very short summary.
        </div>
        <div className="self-start bg-gray-100 px-4 py-2 rounded-lg max-w-xs">Hi Priya, Thank you...</div>
      </div>

      <div className="p-4 border-t flex gap-2">
        <input type="text" placeholder="Type Message" className="flex-1 border px-4 py-2 rounded-full" />
        <button className="bg-primary text-white px-4 py-2 rounded-full">➤</button>
      </div>
    </div>
  );
};

export default ChatWindow;
